import { Component, Inject, Input} from '@angular/core';
import {ObjectsService} from "@app/_services";
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'cards-item-default',
  templateUrl: './cards-item-default.component.html',
  styleUrls: ['./cards-item-default.component.scss']
})
export class CardsItemDefaultComponent {

  constructor(
    @Inject (DOCUMENT) private document: Document,
    private objectsService: ObjectsService,
    private router: Router,
    
  ) {}


  @Input() card:any;

  ngOnInit(){

  }

  get style() {
    return this.objectsService.getValue(this.card, 'card-style').name;
  }
  get header() {
    return this.objectsService.getValue(this.card, 'header');
  }
  get subheader() {
    return this.objectsService.getValue(this.card, 'subheader');
  }
  get text() {
    return this.objectsService.getValue(this.card, 'text');
  }
  get image() {
    let image = this.objectsService.getValue(this.card, 'image')
    if (image) return image.links?.full+'?width=500';
  }
  get link() {
    return this.objectsService.getValue(this.card, 'link');
  }

  navigate(){
    
    if(this.link) {
      if (this.link.startsWith('http')) {this.document.location.href = this.link} else {this.router.navigate([this.link]).then()}
    }
  }


}
